import { observer } from 'mobx-react-lite'
import { useState } from 'react'

import { EmployeeRole } from 'sections/LKSection/modules/EmployeeModule/stores/entity/EmployeeRole/EmployeeRole'
import { Padding } from 'components/ui'
import { Checkbox, Flex, Text } from 'components/uiKit'

type EmployeeRoleItemProps = {
  employeeRole: EmployeeRole
}

export const EmployeeRoleItem = observer(({ employeeRole }: EmployeeRoleItemProps) => {
  const [checked, setChecked] = useState(employeeRole.roleWasChangedInModal)

  const checkboxHandler = (value: boolean) => {
    setChecked(value)
    employeeRole.setRoleWasChangedInModal(value)
  }

  return (
    <Padding py={16} style={{ borderTop: '1px solid #0000001F' }}>
      <Flex justify="space-between" align="center">
        <Flex vertical>
          <Text>{employeeRole.address}</Text>
          <Text type="secondary">ID {employeeRole.externalId}</Text>
        </Flex>

        <Checkbox checked={checked} onChange={(e) => checkboxHandler(e.target.checked)} />
      </Flex>
    </Padding>
  )
})
